import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3d1ac70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-toolbar" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "style"
}
const _hoisted_4 = { class: "row-block" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "文字颜色：", -1))
const _hoisted_6 = { class: "colors" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "row-block" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "填充色：", -1))
const _hoisted_10 = { class: "colors" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  class: "common"
}

import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import type { PPTElement, TableCell } from '@/types/slides'
import { ElementAlignCommands, ElementOrderCommands } from '@/types/edit'
import emitter, { EmitterEvents } from '@/utils/emitter'
import useOrderElement from '@/hooks/useOrderElement'
import useAlignElementToCanvas from '@/hooks/useAlignElementToCanvas'
import useDeleteElement from '@/hooks/useDeleteElement'
import useAddSlidesOrElements from '@/hooks/useAddSlidesOrElements'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import CheckboxButton from '@/components/CheckboxButton.vue'
import Tabs from '@/components/Tabs.vue'
import Divider from '@/components/Divider.vue'
import Button from '@/components/Button.vue'
import ButtonGroup from '@/components/ButtonGroup.vue'
import RadioButton from '@/components/RadioButton.vue'
import RadioGroup from '@/components/RadioGroup.vue'

interface TabItem {
  key: 'style' | 'common'
  label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ElementToolbar',
  setup(__props) {

const colors = ['#000000', '#ffffff', '#eeece1', '#1e497b', '#4e81bb', '#e2534d', '#9aba60', '#8165a0', '#47acc5', '#f9974c', '#c21401', '#ff1e02', '#ffc12a', '#ffff3a', '#90cf5b', '#00af57']

const mainStore = useMainStore()
const slidesStore = useSlidesStore()
const { handleElement, handleElementId, richTextAttrs } = storeToRefs(mainStore)

const { addHistorySnapshot } = useHistorySnapshot()

const updateElement = (id: string, props: Partial<PPTElement>) => {
  slidesStore.updateElement({ id, props })
  addHistorySnapshot()
}

const tabs: TabItem[] = [
  { key: 'style', label: '样式' },
  { key: 'common', label: '布局' },
]
const activeTab = ref('common')

const { orderElement } = useOrderElement()
const { alignElementToCanvas } = useAlignElementToCanvas()
const { addElementsFromData } = useAddSlidesOrElements()
const { deleteElement } = useDeleteElement()

const copyElement = () => {
  const element: PPTElement = JSON.parse(JSON.stringify(handleElement.value))
  addElementsFromData([element])
}

const emitRichTextCommand = (command: string, value?: string) => {
  emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, { action: { command, value } })
}

const updateFontColor = (color: string) => {
  if (!handleElement.value) return
  if (handleElement.value.type === 'text' || (handleElement.value.type === 'shape' && handleElement.value.text?.content)) {
    emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, { action: { command: 'color', value: color } })
  }
  if (handleElement.value.type === 'table') {
    const data: TableCell[][] = JSON.parse(JSON.stringify(handleElement.value.data))
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[i].length; j++) {
        const style = data[i][j].style || {}
        data[i][j].style = { ...style, color }
      }
    }
    updateElement(handleElementId.value, { data })
  }
  if (handleElement.value.type === 'latex') {
    updateElement(handleElementId.value, { color })
  }
}

const updateFill = (color: string) => {
  if (!handleElement.value) return
  if (
    handleElement.value.type === 'text' ||
    handleElement.value.type === 'shape' ||
    handleElement.value.type === 'chart'
  ) updateElement(handleElementId.value, { fill: color })

  if (handleElement.value.type === 'table') {
    const data: TableCell[][] = JSON.parse(JSON.stringify(handleElement.value.data))
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[i].length; j++) {
        const style = data[i][j].style || {}
        data[i][j].style = { ...style, backcolor: color }
      }
    }
    updateElement(handleElementId.value, { data })
  }

  if (handleElement.value.type === 'audio') updateElement(handleElementId.value, { color })
}

return (_ctx: any,_cache: any) => {
  const _component_IconTextBold = _resolveComponent("IconTextBold")!
  const _component_IconTextItalic = _resolveComponent("IconTextItalic")!
  const _component_IconTextUnderline = _resolveComponent("IconTextUnderline")!
  const _component_IconStrikethrough = _resolveComponent("IconStrikethrough")!
  const _component_IconFontSize = _resolveComponent("IconFontSize")!
  const _component_IconAlignTextLeft = _resolveComponent("IconAlignTextLeft")!
  const _component_IconAlignTextCenter = _resolveComponent("IconAlignTextCenter")!
  const _component_IconAlignTextRight = _resolveComponent("IconAlignTextRight")!
  const _component_IconCopy = _resolveComponent("IconCopy")!
  const _component_IconDelete = _resolveComponent("IconDelete")!
  const _component_IconSendToBack = _resolveComponent("IconSendToBack")!
  const _component_IconBringToFrontOne = _resolveComponent("IconBringToFrontOne")!
  const _component_IconBringToFront = _resolveComponent("IconBringToFront")!
  const _component_IconSentToBack = _resolveComponent("IconSentToBack")!
  const _component_IconAlignLeft = _resolveComponent("IconAlignLeft")!
  const _component_IconAlignVertically = _resolveComponent("IconAlignVertically")!
  const _component_IconAlignRight = _resolveComponent("IconAlignRight")!
  const _component_IconAlignTop = _resolveComponent("IconAlignTop")!
  const _component_IconAlignHorizontally = _resolveComponent("IconAlignHorizontally")!
  const _component_IconAlignBottom = _resolveComponent("IconAlignBottom")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Tabs, {
      tabs: tabs,
      value: activeTab.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
      tabsStyle: { marginBottom: '8px' },
      tabStyle: {
        width: '30%',
        margin: '0 10%',
      }
    }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_2, [
      (activeTab.value === 'style')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(ButtonGroup, { class: "row" }, {
              default: _withCtx(() => [
                _createVNode(CheckboxButton, {
                  style: {"flex":"1"},
                  checked: _unref(richTextAttrs).bold,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emitRichTextCommand('bold')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconTextBold)
                  ]),
                  _: 1
                }, 8, ["checked"]),
                _createVNode(CheckboxButton, {
                  style: {"flex":"1"},
                  checked: _unref(richTextAttrs).em,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (emitRichTextCommand('em')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconTextItalic)
                  ]),
                  _: 1
                }, 8, ["checked"]),
                _createVNode(CheckboxButton, {
                  style: {"flex":"1"},
                  checked: _unref(richTextAttrs).underline,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (emitRichTextCommand('underline')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconTextUnderline)
                  ]),
                  _: 1
                }, 8, ["checked"]),
                _createVNode(CheckboxButton, {
                  style: {"flex":"1"},
                  checked: _unref(richTextAttrs).strikethrough,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (emitRichTextCommand('strikethrough')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconStrikethrough)
                  ]),
                  _: 1
                }, 8, ["checked"])
              ]),
              _: 1
            }),
            _createVNode(ButtonGroup, { class: "row" }, {
              default: _withCtx(() => [
                _createVNode(Button, {
                  style: {"flex":"1"},
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (emitRichTextCommand('fontsize-add')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconFontSize),
                    _createTextVNode("+")
                  ]),
                  _: 1
                }),
                _createVNode(Button, {
                  style: {"flex":"1"},
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (emitRichTextCommand('fontsize-reduce')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconFontSize),
                    _createTextVNode("-")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(Divider, { style: {"margin":"20px 0"} }),
            _createVNode(RadioGroup, {
              class: "row",
              "button-style": "solid",
              value: _unref(richTextAttrs).align,
              "onUpdate:value": _cache[7] || (_cache[7] = value => emitRichTextCommand('align', value))
            }, {
              default: _withCtx(() => [
                _createVNode(RadioButton, {
                  value: "left",
                  style: {"flex":"1"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconAlignTextLeft)
                  ]),
                  _: 1
                }),
                _createVNode(RadioButton, {
                  value: "center",
                  style: {"flex":"1"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconAlignTextCenter)
                  ]),
                  _: 1
                }),
                _createVNode(RadioButton, {
                  value: "right",
                  style: {"flex":"1"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconAlignTextRight)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]),
            _createVNode(Divider, { style: {"margin":"20px 0"} }),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colors, (color) => {
                  return _createElementVNode("div", {
                    class: "color",
                    key: color,
                    onClick: ($event: any) => (updateFontColor(color))
                  }, [
                    _createElementVNode("div", {
                      class: "color-block",
                      style: _normalizeStyle({ backgroundColor: color })
                    }, null, 4)
                  ], 8, _hoisted_7)
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colors, (color) => {
                  return _createElementVNode("div", {
                    class: "color",
                    key: color,
                    onClick: ($event: any) => (updateFill(color))
                  }, [
                    _createElementVNode("div", {
                      class: "color-block",
                      style: _normalizeStyle({ backgroundColor: color })
                    }, null, 4)
                  ], 8, _hoisted_11)
                }), 64))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'common')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(ButtonGroup, { class: "row" }, {
              default: _withCtx(() => [
                _createVNode(Button, {
                  style: {"flex":"1"},
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (copyElement()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconCopy, { class: "icon" }),
                    _createTextVNode(" 复制")
                  ]),
                  _: 1
                }),
                _createVNode(Button, {
                  style: {"flex":"1"},
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(deleteElement)()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconDelete, { class: "icon" }),
                    _createTextVNode(" 删除")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(Divider, { style: {"margin":"20px 0"} }),
            _createVNode(ButtonGroup, { class: "row" }, {
              default: _withCtx(() => [
                _createVNode(Button, {
                  style: {"flex":"1"},
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(orderElement)(_unref(handleElement)!, _unref(ElementOrderCommands).TOP)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconSendToBack, { class: "icon" }),
                    _createTextVNode(" 置顶")
                  ]),
                  _: 1
                }),
                _createVNode(Button, {
                  style: {"flex":"1"},
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(orderElement)(_unref(handleElement)!, _unref(ElementOrderCommands).BOTTOM)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconBringToFrontOne, { class: "icon" }),
                    _createTextVNode(" 置底")
                  ]),
                  _: 1
                }),
                _createVNode(Button, {
                  style: {"flex":"1"},
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(orderElement)(_unref(handleElement)!, _unref(ElementOrderCommands).UP)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconBringToFront, { class: "icon" }),
                    _createTextVNode(" 上移")
                  ]),
                  _: 1
                }),
                _createVNode(Button, {
                  style: {"flex":"1"},
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(orderElement)(_unref(handleElement)!, _unref(ElementOrderCommands).DOWN)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconSentToBack, { class: "icon" }),
                    _createTextVNode(" 下移")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(Divider, { style: {"margin":"20px 0"} }),
            _createVNode(ButtonGroup, { class: "row" }, {
              default: _withCtx(() => [
                _createVNode(Button, {
                  style: {"flex":"1"},
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(alignElementToCanvas)(_unref(ElementAlignCommands).LEFT)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconAlignLeft, { class: "icon" }),
                    _createTextVNode(" 左对齐")
                  ]),
                  _: 1
                }),
                _createVNode(Button, {
                  style: {"flex":"1"},
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(alignElementToCanvas)(_unref(ElementAlignCommands).HORIZONTAL)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconAlignVertically, { class: "icon" }),
                    _createTextVNode(" 水平居中")
                  ]),
                  _: 1
                }),
                _createVNode(Button, {
                  style: {"flex":"1"},
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_unref(alignElementToCanvas)(_unref(ElementAlignCommands).RIGHT)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconAlignRight, { class: "icon" }),
                    _createTextVNode(" 右对齐")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(ButtonGroup, { class: "row" }, {
              default: _withCtx(() => [
                _createVNode(Button, {
                  style: {"flex":"1"},
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_unref(alignElementToCanvas)(_unref(ElementAlignCommands).TOP)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconAlignTop, { class: "icon" }),
                    _createTextVNode(" 上对齐")
                  ]),
                  _: 1
                }),
                _createVNode(Button, {
                  style: {"flex":"1"},
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_unref(alignElementToCanvas)(_unref(ElementAlignCommands).VERTICAL)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconAlignHorizontally, { class: "icon" }),
                    _createTextVNode(" 垂直居中")
                  ]),
                  _: 1
                }),
                _createVNode(Button, {
                  style: {"flex":"1"},
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_unref(alignElementToCanvas)(_unref(ElementAlignCommands).BOTTOM)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconAlignBottom, { class: "icon" }),
                    _createTextVNode(" 下对齐")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})